<template>
  <section style="width: 100%">
    <span v-if="mode == 'view'">{{ showLabel }}</span>
    <el-cascader
      ref="myRef"
      style="width: 100%"
      v-else
      v-model="selectVal"
      :options="model.data"
      :clearable="clearable"
      :props="prop"
      :show-all-levels="showAllLevels"
    />
  </section>
</template>
<script setup>
import { computed, reactive, watch, watchEffect, ref, onUnmounted } from 'vue'
import { useStore } from 'vuex'
const { lazyList } = TdUI.api.admin.region
const props = defineProps({
  modelValue: {
    type: [Object, String, Number, Array],
    default: ''
  },
  /**是否多选 */
  multiple: {
    type: Boolean,
    default: false
  },
  mode: {
    type: String,
    default: null
  },
  lazy: {
    type: Boolean,
    default: true
  },
  /**省两位 市4位 区6位 */
  regionLevel: {
    type: Number,
    default: 3 //1省2市3区
  },
  /**显示全级别路径 */
  showAllLevels: {
    type: Boolean,
    default: true
  },
  /**是否根据租户限制 */
  isLimit: {
    type: Boolean,
    default: true
  },
  checkStrictly: {
    type: Boolean,
    default: false
  },
  type: {
    type: String,
    default: 'all' //self or all self本区划 all 所有 custom 自定义
  },
  customCode: {
    type: String,
    default: ''
  },
  /** 过滤第一级用 */
  areaCode: {
    type: String,
    default: ''
  },
  /**是否显示本级 */
  isShowContainSelf: {
    type: Boolean,
    default: false
  },
  clearable: {
    type: Boolean,
    default: true
  }
})
const model = reactive({
  data: [],
  selectNode: [],
  cacheData: []
})
const store = useStore()
const myRef = ref(null)
const userInfo = computed(() => {
  return store.state.app.account.userInfo
})
const tenantId = computed(() => {
  return store.state.app.system.tenantId
})
const emit = defineEmits(['update:modelValue', 'change'])
const prop = computed(() => {
  return {
    lazy: props.lazy,
    label: 'title',
    value: 'value',
    emitPath: false,
    checkStrictly: props.checkStrictly,
    multiple: props.multiple,
    lazyLoad: lazyLoad
  }
})
const modelValueToString = () => {
  if (props.modelValue != undefined && props.modelValue != null) {
    return props.multiple
      ? props.modelValue.indexOf(',') > 0
        ? props.modelValue.split(',').map(e => e.toString())
        : props.modelValue == ''
        ? []
        : [props.modelValue.toString()]
      : props.modelValue.toString()
  } else {
    return props.multiple ? [] : ''
  }
}
const showLabel = computed(() => {
  let data = getSelectedData(selectVal.value)
  if (data) {
    let allData = TdUI.utils.extend.flatMapParent(data)

    return Array.isArray(allData)
      ? allData
          .reverse()
          .map(z => z.title)
          .join('/')
      : selectVal.value
  }

  return Array.isArray(data) ? data.map(z => z.title).join(',') : data ? data.title : selectVal.value
})

/**绑定值 */
const selectVal = computed({
  get() {
    return modelValueToString()
  },
  set(val) {
    emit('update:modelValue', Array.isArray(val) ? val.join(',') : val)
    let data = getSelectedData(val)
    emit('change', val, data)
  }
})
const getSelectedData = val => {
  let data
  if (props.multiple) {
    data = model.cacheData.filter(z => val.includes(z[prop.value.value]))
  } else {
    data = model.cacheData.find(z => z[prop.value.value] == val)
  }
  return data
}
const getCheckedNodes = (leafOnly = false) => {
  return myRef.value.getCheckedNodes(leafOnly)
}

const lazyLoad = async (node, resolve, flag) => {
  let data = []
  if (node.data.id) {
    let result = await lazyList({ parentCode: node.data.id, isShowContainSelf: props.isShowContainSelf ? 1 : 0 })
    data = result.data
  } else {
    let result = await lazyList({
      parentCode:
        props.type == 'all'
          ? userInfo.value.areaCode == '000000'
            ? 0
            : '000000'
          : props.type == 'custom'
          ? props.customCode
          : userInfo.value.areaCode == '0000000'
          ? '0'
          : userInfo.value.areaCode,
      isShowContainSelf: props.isShowContainSelf ? 1 : 0
    })

    data = result.data
    /**选择当前人所在的省份 */
    if (props.type == 'all' && props.areaCode) {
      let province = props.areaCode.substring(0, 2) + '0000'
      data = data.filter(z => (z.code + '000000').substring(0, 6) == province)
    }
    /**选择当前人所在的省份 */
    if (props.type == 'custom' && props.areaCode) {
      let cityCode = userInfo.value.areaCode //六位
      if (cityCode != 0) {
        data = data.filter(z => z.code == cityCode)
      }
    }
  }
  data = data.map(e => {
    return {
      title: e.name, //两位是省 4位是市 6位是区
      value: (e.code + '000000').substring(0, 6),
      id: e.id,
      pid: e.parentId,
      leaf: !e.hasChildren
    }
  })
  //
  if (tenantId.value != '000000' && props.isLimit) {
    if (userInfo.value && userInfo.value.areaCode) {
      let s = userInfo.value.areaCode.substring(0, 2)
      if (parseInt(s) != 0) {
        data = data.filter(z => z.value.indexOf(s) > -1)
      }
    }
  }

  model.cacheData = [...model.cacheData, ...data]
  transData(model.cacheData, true)
  resolve(data)

  return flag ? data : []
}
/**数据转换 */
const transData = (a, showParent) => {
  let r = [],
    hash = {},
    id = 'id',
    pid = 'pid',
    children = 'children',
    len = a.length

  if (len == 0) return []
  for (var i = 0; i < len; i++) {
    hash[a[i][id]] = a[i]
  }

  for (var j = 0; j < len; j++) {
    var aVal = a[j],
      hashVP = hash[aVal[pid]]
    if (hashVP) {
      if (!hashVP[children]) hashVP[children] = []
      hashVP[children].push(aVal)
      showParent && (aVal.parent = hashVP)
    } else {
      r.push(aVal)
    }
  }
  return r
}
const editInit = async () => {
  if (!props.multiple) {
    let s = parseInt(props.modelValue.toString().split('').reverse().join('')).toString()
    let sLength = s.length
    let i = 0
    let data = []

    while (true) {
      if (i == 0) {
        let result = await lazyLoad({ data: {} }, () => {}, true)
        data = [...data, ...result]
      } else {
        let result = await lazyLoad({ data: { id: (props.modelValue.toString().substring(0, i) + '000000').substring(0, 6) } }, () => {}, true)
        data = [...data, ...result]
      }
      i = i + 2
      if (i >= sLength) break
    }
    if (tenantId.value != '000000') {
      let s = userInfo.value.areaCode.substring(0, 2)
      if (parseInt(s) != 0) {
        data = data.filter(z => z.value.indexOf(s) > -1)
      }
    }
    if (userInfo.value.areaCode == '000000') {
      let result = await lazyLoad({ data: { id: '000000' } }, () => {}, true)
      data = [...data, ...result]
    }

    model.data = data.filter(e => !e.parent)
  }
}

const viewInit = async () => {
  if (!props.multiple) {
    let s = parseInt(props.modelValue.toString().split('').reverse().join('')).toString()
    let sLength = s.length
    let i = 0
    let data = []

    while (true) {
      if (i == 0) {
        let result = await lazyLoad({ data: {} }, () => {}, true)
        data = [...data, ...result]
      } else {
        let result = await lazyLoad({ data: { id: (props.modelValue.toString().substring(0, i) + '000000').substring(0, 6) } }, () => {}, true)
        data = [...data, ...result]
      }
      i = i + 2
      if (i >= sLength) break
    }
    if (tenantId.value != '000000') {
      let s = userInfo.value.areaCode.substring(0, 2)
      if (parseInt(s) != 0) {
        data = data.filter(z => z.value.indexOf(s) > -1)
      }
    }
    if (userInfo.value.areaCode == '000000') {
      let result = await lazyLoad({ data: { id: '000000' } }, () => {}, true)
      data = [...data, ...result]
    }
    model.data = data
  }
}

const stop1 = watch(selectVal, (val, oldVal) => {
  if (val != oldVal && props.mode == 'view') {
    viewInit()
  }
})
const stop2 = watch(selectVal, (val, oldVal) => {
  if (val != oldVal && props.mode == 'edit') {
    let findData = model.cacheData.find(e => e.value.includes(props.modelValue))
    if (!findData) {
      editInit()
    }
  }
})
onUnmounted(() => {
  stop1()
  stop2()
})
defineExpose({ getCheckedNodes })
</script>
<script>
export default {
  name: 'RegionSelectV2',
  viewDisplay: true
}
</script>
